import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vaata, kas oled unustanud midagi oma soovinimekirja

  <span style="color:#85c1dc;">**FI:**</span>
  Kirjaudu sisään ja katso toivelistasi

  <span style="color:#85c1dc;">**RU:**</span>
  Войдите и просмотрите свой список желаний
*/
/* @__NO_SIDE_EFFECTS__ */
const m2018 = msg(
  mf`Vaata, kas oled unustanud midagi oma soovinimekirja`,
  mf`Kirjaudu sisään ja katso toivelistasi`,
  mf`Войдите и просмотрите свой список желаний`,
)

export { m2018 as 'w.basket.empty.first.title' }